'use client';

export interface MagazineSeriesCategoryUnitProps {
    label: string;
}

export default function MagazineSeriesCategoryUnit({ label }: MagazineSeriesCategoryUnitProps) {
    return (
        <span className="inline-flex items-center px-2.5 py-0.5 rounded-lg border border-color-base-2 border-opacity-30 bg-color-base-2 bg-opacity-10 whitespace-nowrap font-corp font-medium text-xs text-color-base-2">
            {label}
        </span>
    );
}
